import { VertexEvent } from '../spline/coneSpanner/VertexEvent';
export class BasicVertexEvent extends VertexEvent {
    constructor(obstacle, p) {
        super(p);
        this.Obstacle = obstacle;
    }
}
//# sourceMappingURL=BasicVertexEvent.js.map